import React, { Component } from "react";
import Images from "./Images";
import { connect } from "react-redux";
import { Modal } from "antd";
import { validateCouponReset } from "../../redux/actions/generalActions";
import CheckCoupon from "./CheckCoupon";

export class CouponModal extends Component {
  state = {
    isModalOpen: false,
  };
  showModal = () => {
    this.props.validateCouponReset();
    this.setState({
      isModalOpen: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  render() {
    const { signedIn } = this.props;
    return (
      <div>
        {signedIn ? (
          <div className="coupon-wrapper">
            <img src={Images.PromoIcon} alt='coupon-icon' onClick={() => this.showModal()} />
            <Modal
              visible={this.state.isModalOpen}
              onCancel={this.handleCancel}
              className="coupon-modal"
              footer={null}
              closable={false}
            >
              <div className="heading">
                <div>Check Your Promo Code</div>
                <div className="close-icon" onClick={() => this.handleCancel()}>
                  <img src={Images.CloseIcon} alt="close-icon" />
                </div>
              </div>
              <div className="content">
                <CheckCoupon />
              </div>
            </Modal>
          </div>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    signedIn: state.auth.signedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  validateCouponReset: () => {
    dispatch(validateCouponReset());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponModal);
